import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { router } from './helpers/router';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

if (navigator.userAgent.indexOf('iPhone') >= 0 && navigator.userAgent.indexOf('Instagram') >= 0) {
  window.location.replace("x-safari-https://onethingkneaded.com")
}

window.caches.open("workbox-precache-v2-https://onethingkneaded.com/ - https://onethingkneaded.com").then((cache) => {
  console.log("found it: " + cache)
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();